<app-header [isStudent]="false"></app-header>
<div class="upload-container" *ngIf="!file">
  <div class="title-header">Upload File</div>
  <div>
    Once your file is uploaded, the Similarity Report will open in a new tab. This process may take 3 to 5 minutes. Thank you for your patience!
  </div>

  <div class="scan-options-container">
    <div class="scan-options-title">
      Scan options - select all that apply
    </div>
    <div class="scan-option">
      <label>
        <input type="checkbox" class="scan-checkbox" [(ngModel)]="isInternalDb"/>
        <span class="scan-label-title">Internal Database</span>
        <div class="scan-label-desc">
          Provides matches against the WGU internal database.
        </div>
      </label>
    </div>
    <div class="scan-option">
      <label>
        <input type="checkbox" class="scan-checkbox" [(ngModel)]="isOnline"/>
        <span class="scan-label-title">Online</span>
        <div class="scan-label-desc">
          Provides matches against internet sources.
        </div>
      </label>
    </div>
    <div class="scan-option">
      <label>
        <input type="checkbox" class="scan-checkbox" [(ngModel)]="isStudent" (ngModelChange)="onStudentValueChange($event)"/>
        <span class="scan-label-title">Student Exclusion</span>
        <div class="scan-label-desc">
          Excludes self-plagiarism matches to the Student ID entered below.
        </div>
      </label>
      <div class="input-options">
        <input type="text" class="scan-input-interior" placeholder="Student ID" [(ngModel)]="studentId" [disabled]="!isStudent"/>
        <span class="padding-8">- or -</span>
        <input type="text" class="scan-input-interior" placeholder="WGU ID" [(ngModel)]="wguId" [disabled]="!isStudent"/>
      </div>
    </div>
    <div class="scan-option">
      <label>
        <input type="checkbox" class="scan-checkbox" [(ngModel)]="isTaskId" (ngModelChange)="onTaskValueChange($event)"/>
        <span class="scan-label-title">Task</span>
        <div class="scan-label-desc">
          To limit your results to a specific task, enter the Task ID.
        </div>
      </label>
      <div class="input-options" style="width: 100%;">
        <input type="text" class="scan-input" placeholder="Task ID" [(ngModel)]="taskId" [disabled]="!isTaskId"/>
      </div>
    </div>
    <div class="scan-upload-row">
      <input type="file" class="file-upload" (change)="onFileUpload($event)" #fileUpload>
      <span class="scan-upload-note">NOTE: This upload process will open a new tab. Be sure to save your URL!</span>
      <button class="scan-upload-btn" (click)="fileUpload.click()" [disabled]="isUploadDisabled()">UPLOAD</button>
    </div>
  </div>
</div>

<div class="upload-container" *ngIf="file">
  <div class="title-header" *ngIf="!scanComplete && !scanError">Scan Upload in Progress</div>
  <div class="title-header" *ngIf="scanComplete && !scanError">Scan Uploaded Successfully</div>
  <div class="title-header" *ngIf="scanError">Scan Error</div>

  <div *ngIf="!scanComplete && !scanError">
    <mat-progress-spinner class="spinner" [diameter]="40" mode="indeterminate"></mat-progress-spinner>Scanning file <b> {{ fileName }} </b>
    <br>
    Checking Copyleaks for completed file (Attempt {{ displayRetryCount + 1 }}) in {{ displayTimer / 1000 }} seconds...
    <br>
    <br> 
    <br>
    Please save the URL provided below. The scan may take 3 to 5 minutes to complete. Thank you for your patience!
  </div>
  <div *ngIf="scanError">
    Error Scanning file <b> fileName </b>
    <br>
    Max number of retries exceeded
  </div>
  <div *ngIf="scanComplete">
    File <b>{{ fileName }}</b> has been successfully scanned. <br><br> A new tab has been opened with the completed scan. Please save the URL provided below if you wish to return to this scan.
  </div>
  <button class="copyButton" mat-stroked-button color="primary" (click)="copyUrl()">COPY</button>
  <span class="scanUrl" >{{ scanUrl }}</span>
  <div class="noteSection">
    You may save this URL, close this page, and return back later. When complete, this page will transfer to the appropriate CopyLeaks page (make sure you disable your pop up blocker for this page).
  </div>
  <button *ngIf="scanComplete" class="uploadButton" style="margin-top: 0;" mat-flat-button color="primary" (click)="refresh()">UPLOAD NEW FILE</button>
</div>